// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import layer from 'vue-layer'
import App from './App'
import router from './router'
import leaflet from 'leaflet'
import store from './store'
import httpRequest from '@/utils/httpRequest'
import 'babel-polyfill'
import VueCookie from 'vue-cookie' // api: https://github.com/alfhen/vue-cookie
import '@/assets/style/page.css'
// import Pagination from 'vue-pagination-2' // 引入分页依赖
// Vue.component('pagination', Pagination) // 引用全局分页组件

Vue.use(VueCookie)
// 挂载全局
Vue.prototype.$http = httpRequest
Vue.prototype.L = leaflet
Vue.prototype.$layer = layer(Vue)
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
let vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})
Vue.use({
  vm
})



// WEBPACK FOOTER //
// ./src/main.js